import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/Element.js';
import './plugins/Modal.ts';
import './plugins/Moment.js';
import './plugins/Cookie.ts';
import {i18n} from './plugins/VueI18n';
import '@/assets/style.css';
import '@/assets/editor-style.css';
import './plugins/AxiosInterceptor';
import './plugins/raygun.ts';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
